/**
 * One provider-neutral taxonomy shared across COI, Stripe and Zuora, so those
 * failures sit in a single Mixpanel breakdown.
 */
export type ErrorCategory =
  | 'none'
  | 'generation_timeout'
  | 'user_input'
  | 'declined'
  | 'authentication'
  | 'session_expired'
  | 'session_unavailable'
  | 'interrupted'
  | 'form_load'
  | 'server_error'
  | 'client_error'
  | 'network'
  | 'unknown';

const USER_INPUT_STATUSES = new Set([400, 409, 422]);

export const toApiErrorCategory = (status: number): ErrorCategory => {
  if (status === 401 || status === 403) return 'authentication';
  if (USER_INPUT_STATUSES.has(status)) return 'user_input';
  if (status >= 500) return 'server_error';
  if (status >= 400) return 'client_error';
  return 'unknown';
};
